import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

import { getStoredLocation, storeLocation } from './../lib/utils';

export const ConfigContext = createContext(null);

const params = new URLSearchParams(document.location.search);

export function ConfigProvider(props) {
  const itemPropMap = {
    streetaddress: 'streetAddress',
    city: 'addressLocality',
    zipcode: 'postalCode',
    state: 'addressRegion'
  };

  const initialSettings = {
    isHeavy: !!window.ntParams?.nht,
    enableMobileMap: false,
    disableChosenTyre: false,
    mapTitle: '',
    addressFields: ['streetaddress', 'city', 'zipcode'],
    nameFields: ['company_name', 'company_name_extra'],
    reorderCompanyName: false,
    skipLandingPage: false,
    countryCode: window.ntLang,
    distanceUnit: 'km',
    resourceTimestamp: Date.now(),
    studioUrl: 'https://nokiantyres.studio.crasman.cloud/pub/',
    includeServices: false,
    showServices: false,
    initialLocation: null,
    mapType: 'default',
    restrictAutocompleteToCountries: [],
    includeCities: false,
    filters: [],
  };
  const windowSettings = window.ntDealerConfig || {};
  for(let key in initialSettings) {
    if (typeof windowSettings[key] === 'undefined') {
      continue;
    }
    if ((key === 'addressFields' || key === 'nameFields') && windowSettings[key].length === 0) {
      continue;
    }

    if (key === 'enableMobileMap') {
      initialSettings.enableMobileMap = Array.isArray(windowSettings.enableMobileMap) ? windowSettings.enableMobileMap[0] : windowSettings.enableMobileMap;
    }
    else {
      initialSettings[key] = windowSettings[key];
    }
  }

  const skipLandingParam = params.get('skip_landing');
  if (skipLandingParam) {
    initialSettings.skipLandingPage = true;
  }

  const citiesParam = params.get('includeCities');
  if (citiesParam) {
    initialSettings.includeCities = true;
  }

  // Get user saved location from session, but only skip landing page if param exists
  const storedLocation = getStoredLocation();
  const useLocationParam = params.get('use_location');
  if (storedLocation && useLocationParam) {
    console.log('User saved location found', storedLocation);
    initialSettings.initialLocation = storedLocation;
    initialSettings.skipLandingPage = true;
  }

  if (windowSettings.initialLocation) {
    // save city map location to session
    storeLocation(windowSettings.initialLocation);
  }

  const activeFilters = (params.has('filters[]') ? params.getAll('filters[]') : (params.has('filters') ? params.get('filters').split(',') : [])).filter(value => value.length > 0);
  const filters = initialSettings.includeServices ? window.ntServiceFilters : window.ntFilters;
  if (filters) {
    initialSettings.filters = filters.filter(filter => initialSettings.isHeavy ? filter.product_category : filter.company_type).map(filter => {
      return {
        apiValue: initialSettings.isHeavy ? filter.product_category : filter.company_type,
        value: filter.id,
        name: filter.name,
        productCategory: typeof filter.product_category === 'number' ? filter.product_category : null,
        companyType: typeof filter.company_type === 'number' ? filter.company_type : null,
        active: initialSettings.isHeavy ? activeFilters.includes(String(filter.product_category)) : activeFilters.includes(String(filter.company_type)),
        showUI: filter.show_ui,
      };
    });
  }

  const [settings, setSettings] = useState(initialSettings);

  return (
    <ConfigContext.Provider
      value={{
        config: settings,
        itemPropMap,
        setConfig: setSettings
      }}
    >
      {props.children}
    </ConfigContext.Provider>
  );
}

ConfigProvider.propTypes = {
  children: PropTypes.node,
};
